
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/web-scraping-services",
      function () {
        return require("private-next-pages/web-scraping-services.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/web-scraping-services"])
      });
    }
  